/**
 * Dev-only diagnostic sink for the analytics module — the single place this
 * module is permitted to write to the console. No-ops in production so a
 * fail-open swallow never leaks noise to end users (CLAUDE.md: no console.log).
 */
export function devWarn(message: string, detail?: unknown): void {
  if (process.env.NODE_ENV === "production") {
    return;
  }
  // eslint-disable-next-line no-console
  console.warn(`[analytics] ${message}`, detail ?? "");
}
